export type OffersBrowseTranslation = {
  copy: {
    asVersion: {
      editable: string;
      fromOlder: string;
      sourceKept: string;
      sourceSent: string;
      title: string;
    };
    button: {
      cancel: string;
      submit: string;
      submitAsVersion: string;
    };
    form: {
      eventDateFrom: string;
      eventDateTo: string;
      location: string;
      name: string;
      noOfGuests: string;
    };
    title: string;
    titleAsVersion: string;
  };
  openButton: string;
  outOfEventTerm: {
    label: string;
    tooltip: string;
  };
  predefinedFilters: {
    all: string;
    dropdownLabel: string;
  };
  tabs: {
    fromProcesses: string;
    predefined: string;
  };
  title: string;
  useOffer: string;
};

export const offersBrowseTranslation: OffersBrowseTranslation = {
  copy: {
    asVersion: {
      editable:
        'To będzie szkic z tą samą treścią — możesz go dowolnie edytować i wysłać klientowi. ' +
        'Liczbę osób, termin i miejsce możesz zmienić od razu poniżej.',
      fromOlder:
        'Tworzysz ją z wersji {{source}}, choć najnowsza to wersja {{latest}} — nowa wersja ' +
        'dostanie treść wersji {{source}}.',
      sourceKept: 'Wersja {{source}} zostaje bez zmian.',
      sourceSent:
        'Wersja {{source}} zostaje bez zmian jako zapis tego, co dostał klient — do niej też ' +
        'możesz zawsze wrócić.',
      title: 'Powstanie wersja {{version}}',
    },
    button: {
      cancel: 'Anuluj',
      submit: 'Utwórz kopię',
      submitAsVersion: 'Utwórz wersję {{version}}',
    },
    form: {
      eventDateFrom: 'Data rozpoczęcia',
      eventDateTo: 'Data zakończenia',
      location: 'Lokalizacja',
      name: 'Nazwa',
      noOfGuests: 'Liczba gości',
    },
    title: 'Podaj parametry kopiowanej oferty',
    titleAsVersion: 'Nowa wersja oferty',
  },
  openButton: 'Przeglądaj oferty',
  outOfEventTerm: {
    label: 'Niedostępny w terminie wydarzenia',
    tooltip:
      'Reguły dostępności tego szablonu nie obejmują terminu wydarzenia. Mimo to możesz go użyć — to tylko ostrzeżenie.',
  },
  predefinedFilters: {
    all: 'Wszystkie',
    dropdownLabel: 'Typ predefiniowanej oferty',
  },
  tabs: {
    fromProcesses: 'Oferty z procesów',
    predefined: 'Predefiniowane',
  },
  title: 'Wszystkie oferty',
  useOffer: 'Użyj tej oferty',
};
